<script lang="jsx">
import CartMixin from '@/plans/mx/shopping-cart.vue';
import { capacityFormatter, capitalizeFirstLetter } from '@/common/utils';
import { BILLING_CYCLE } from '@/common/constants';

export default {
  name: 'EventServicesCart',

  extends: CartMixin,

  methods: {
    mx_title(title, price, classList = ['text-capitalize'], planCode, parentCategory) {
      classList.push('opc-cart-item__title', '__PLACEHOLDER_first_title__');
      let _price = typeof price === 'number' ? this.$money(price) : price;

      return (
        <h3 class={classList.join(' ')}>
          <span
            className="opc-cart-item__subtitle"
            data-parent-category-title={parentCategory}
            data-plan-code-title={planCode}
          >
            {title}
          </span>
          {price !== undefined && <span class="opc-cart-item__value text-no-capitalize">{_price}</span>}
        </h3>
      );
    },

    $renderPrice() {
      if (this.mx_plans.length < 1) return null;
      return (
        <div class="opc-cart-item">
          {this.mx_title(
            this.$t('billing.event_services.title'),
            this.$t('billing.event_services.price_included'),
            ['text-no-capitalize'],
            null,
            this.mx_plans[0].parent_category,
          )}
          {this.mx_plans.map((plan) => {
            return (
              <div class="opc-event-services-cart__sub-project">
                {this.mx_subTitle(
                  `${capacityFormatter(plan.participants)} ${capitalizeFirstLetter(this.$t('billing.attendees'))}`,
                  undefined,
                  plan?.plan_code,
                )}
                <div class="opc-cart-item__text">{this.$t('billing.event_services.x_hours_per_license')}</div>
                {this.mx_cycle(
                  plan.billing_cycle,
                  plan.billing_cycle === BILLING_CYCLE.ONE_TIME
                    ? this.$t('billing.single_use_meeting.within_three_months')
                    : '',
                )}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-event-services-cart {
  &__sub-project {
    padding-bottom: 8px;
    &:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
